/**
 * returns redirectable url
 * after successful login to midway, url will redirect to CMT ui for stages other than local
 * Sample URL for gamma,
 * https://midway-auth.amazon.com/login?next=%2FSSO%2Fredirect%3Fredirect_uri%3Dhttps%253A%252F%252Fus-west-2.gamma.categorymanagement.wwgs.amazon.dev%253A443%252F%26client_id%3Dhttps%253A%252F%252Fus-west-2.gamma.categorymanagement.wwgs.amazon.dev%253A443%26scope%3Dopenid%26response_type%3Did_token%26nonce%3Dsentry_handler_version%3DMidwayNginxModule-1.6-1%26&noauth=false&require_digital_identity=false
 * if this url doesn't work, copy-paste link into your browser and try to fix accordingly.
 */
const getMidwayRedirectRoutes = (stage: string) => {
  const midwayRedirectRoute =
    stage === 'test'
      ? 'https://midway-auth.amazon.com/login?next=%2FSSO'
      : `https://midway-auth.amazon.com/login?next=%2FSSO%2Fredirect%3Fredirect_uri%3Dhttps%253A%252F%252Fus-west-2.${stage}.categorymanagement.wwgs.amazon.dev%253A443%252F%26client_id%3Dhttps%253A%252F%252Fus-west-2.${stage}.categorymanagement.wwgs.amazon.dev%253A443%26scope%3Dopenid%26response_type%3Did_token%26nonce%3Dsentry_handler_version%3DMidwayNginxModule-1.6-1%26&noauth=false&require_digital_identity=false`;
  return midwayRedirectRoute;
};

export default getMidwayRedirectRoutes;
